import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {LanguageService} from "../../services/language.service";
import { MatButton } from '@angular/material/button';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatButton, TranslocoModule]
})
export class AuthComponent implements OnInit{
  private authService = inject(AuthService);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  languageService = inject(LanguageService);

  loginForm!: FormGroup;
  submitError = false;
  submitErrorConnexion = false;

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [Validators.required]),
    });
  }

  login() {
    if (this.loginForm?.valid) {
      this.authService.signIn(this.loginForm.value.email, this.loginForm.value.password)
        .then(() => {
          this.router.navigate(['/']);
        })
        .catch((error) => {
          if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
            this.submitErrorConnexion = true;
          } else {
            this.submitErrorConnexion = true;
            throw error;
          }
        });
    } else {
      this.submitError = true;
    }
  }

  forgetPassword() {
    this.router.navigate(['/forget-password'])
  }
}
